<template>
  <div id="app" v-if="show">
    <router-view/>
  </div>
</template>

<script>
/* eslint-disable */
import CryptoJS from 'crypto-js'
export default {
  name: 'App',
  data () {
  	return {
  		show: false,
  		appData: {}
  	}
  },
  created () {
  	this.getData()
		window.getLoginData = () => {
			this.getData('1')
		}
		this.$bus.$on('goTomobilecode', () => {
			this.$tool.changeURL('http://action:8808/?callBack=getLoginData()')
		})
		this.$bus.$on('revatmobilecode', (fun) => {
			this.loginOrRegister(this.appData.mobilecode, this.appData, fun)
		})
		window.getHistryCode = function (userCode) {
			localStorage.setItem('ZFTZX_userCode', userCode || '')
		}
  },
  methods: {
  	getData (type) {
  		this.$tool.getzftData((appData) => {
  			this.appData = appData
			if (appData.mobilecode) {
				this.$tool.getLocalValue('unifiedAccount', (data) => {
					if (data && data !== '(null)') {
						data = data.replace(/\s*/g, '')
						var obj = this.decryptByBASE(data)
						obj = JSON.parse(obj)
						this.$store.dispatch('getdeviceId', obj.tztudid)
						localStorage.setItem('ZFT_tztudid', obj.userId)
						localStorage.setItem('ZFT_authorization', obj.ticket)
						this.show = true
						if (type === '1') {
							GoBackOnLoad && GoBackOnLoad()
						}
					} else {
						if (type === '1') {
							this.loginOrRegister(appData.mobilecode, appData, GoBackOnLoad)
						} else {
							this.loginOrRegister(appData.mobilecode, appData)
						}
					}
					this.$tool.changeURL('http://action:60058/?jsCallback=getHistryCode')
				})
				localStorage.setItem('ZFTZX_mobilecode', appData.mobilecode)
			} else {
				localStorage.setItem('ZFTZX_mobilecode', '')
				this.$store.dispatch('getdeviceId', appData.tztudid || '')
				localStorage.setItem('ZFT_tztudid', appData.tztudid || '')
				localStorage.setItem('ZFT_authorization', appData.tztudid || '')
				localStorage.setItem('ZFTZX_userCode', '')
				this.show = true
			}
			localStorage.setItem('ZFTZX_touristId', appData.tztudid || '')
		})
  	},
  	encryptByAES (message, key, iv) { // AES加密
		  	var keyHex1 = CryptoJS.enc.Utf8.parse(key) // 密钥
		  	var iv1 = CryptoJS.enc.Utf8.parse(iv) // 偏移量
		  	var encrypted = CryptoJS.AES.encrypt(message, keyHex1, {
		    	iv: iv1,
		    	mode: CryptoJS.mode.CBC,
		    	padding: CryptoJS.pad.Pkcs7
		  	})
		  	return encrypted.toString()
		},
		decryptByBASE (str) {
			var parsedWordArray = CryptoJS.enc.Base64.parse(str)
			var parsedStr = parsedWordArray.toString(CryptoJS.enc.Utf8)
			return parsedStr
		},
		encryptByBASE (i) {
			var str = CryptoJS.enc.Utf8.parse(i)
			var base64 = CryptoJS.enc.Base64.stringify(str)
			return base64
		},
		loginOrRegister (phone, appData, fun) {
			if (!phone) {
				this.$store.dispatch('getdeviceId', appData.tztudid || '')
				localStorage.setItem('ZFT_tztudid', appData.tztudid || '')
				localStorage.setItem('ZFT_authorization', appData.tztudid || '')
				this.show = true
				return
			}
			var mobileTel = encodeURIComponent(this.encryptByAES(phone, 'infoplat_app_pay', 'ipsIPS123IPSabc1'))
			this.$fun.postNewsData('/api/v1/info-plat-service/logincorrelation/tellerLogin?phone=' + mobileTel + '&deviceId=' + appData.tztudid).then(res => {
				this.show = true
				if (res.errorCode === 200) {
					var obj = {
						userId: res.data.userId,
						ticket: res.data.ticket
					}
					this.$store.dispatch('getdeviceId', appData.tztudid)
					localStorage.setItem('ZFT_tztudid', obj.userId)
					localStorage.setItem('ZFT_authorization', obj.ticket)
					this.$tool.setLocalValue('unifiedAccount', this.encryptByBASE(JSON.stringify(obj)))
					fun && fun()
				} else {
					this.$store.dispatch('getdeviceId', appData.tztudid || '')
					localStorage.setItem('ZFT_tztudid', appData.tztudid || '')
					localStorage.setItem('ZFT_authorization', appData.tztudid || '')
					this.show = true
				}
			})
		}
  }
}
/* eslint-enable */
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue